import dayjs from 'dayjs';
import lodashGet from 'lodash/get';
import lodashSet from 'lodash/set';
import { apis } from 'api';
import { apiHolder } from 'api';
import { getIn18Text } from 'api';
const systemApi = apiHolder.api.getSystemApi();
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const durationMin = 5 * 60 * 1000;
const DURATION_MIN = 5 * 60 * 1000;
export const addHHM = (time, param = {
    format: 'HH:mm',
    [5 * 60 * 1000]: getIn18Text('GANGGANG'),
}) => {
    const timeZone = mailConfApi.getTimezone();
    const now = systemApi.getDateByTimeZone(new Date(), timeZone);
    const timeDayjs = dayjs(systemApi.getDateByTimeZone(time, timeZone));
    const aliasKeyList = Object.keys(param)
        .filter(item => !Number.isNaN(item))
        .map(item => Number(item));
    const duration = now.valueOf() - timeDayjs.valueOf();
    while (aliasKeyList.length) {
        const minNumber = Math.min(...aliasKeyList);
        if (minNumber >= duration) {
            return param[`${minNumber}`];
        }
        const $index = aliasKeyList.indexOf(minNumber);
        aliasKeyList.splice($index, 1);
    }
    return timeDayjs.format(param.format);
};
export const isToday = (time) => {
    const timeZone = mailConfApi.getTimezone();
    const now = dayjs(systemApi.getDateByTimeZone(new Date(), timeZone)).format('YYYY-MM-DD');
    const timeDayjs = dayjs(systemApi.getDateByTimeZone(time, timeZone)).format('YYYY-MM-DD');
    return now === timeDayjs;
};
export const formatTime = (time) => {
    const timeZone = mailConfApi.getTimezone();
    const now = dayjs(systemApi.getDateByTimeZone(new Date(), timeZone));
    const timeDayjs = dayjs(systemApi.getDateByTimeZone(time, timeZone));
    const realDuration = now.valueOf() - timeDayjs.valueOf();
    const keys = ['year', 'month', 'day', 'date'];
    const [year, month, day, date] = keys.map(key => now.get(key));
    const today = dayjs(`${year}/${month + 1}/${date}`);
    const firstDayOfWeek = today.subtract(day);
    if (timeDayjs.year() !== now.year()) {
        return timeDayjs.format(getIn18Text('YYYYNIANMYDR'));
    }
    if (timeDayjs.month() !== now.month() && firstDayOfWeek.valueOf() > timeDayjs.valueOf()) {
        return timeDayjs.format(getIn18Text('MYUEDRIIM'));
    }
    if (now.date() - timeDayjs.date() === 1) {
        return getIn18Text('ZUOTIAN');
    }
    if (timeDayjs.date() !== now.date()) {
        return timeDayjs.format(getIn18Text('MYUEDRIIM'));
    }
    if (realDuration >= durationMin) {
        return timeDayjs.format('a').replace('am', getIn18Text('SHANGWU')).replace('pm', getIn18Text('XIAWU'));
    }
    return '';
};
export const validate = (msg) => lodashGet(msg, 'timeTagIndex', -1);
export const addTimeline = (msgs, callback = validate) => {
    const twoDimensionalArr = splitMsgs(msgs, callback);
    const result = twoDimensionalArr.reduce((total, subArr) => {
        const startTagIndex = lodashGet(subArr, '[0].timeTagIndex', -1);
        if (startTagIndex !== -1) {
            total.push(subArr);
            return total;
        }
        const preSubArr = total[total.length - 1] || [];
        const curTimetagIndex = computeTagIndex(lodashGet(preSubArr, '[0].time', 0), lodashGet(preSubArr, `[${preSubArr.length}-1].timeTagIndex`, 0), lodashGet(subArr, '[0].time'));
        lodashSet(subArr, '[0].timeTagIndex', curTimetagIndex);
        if (curTimetagIndex === 0) {
            total.push(subArr);
        }
        else {
            total[total.length - 1] = [...total[total.length - 1], ...subArr];
        }
        return total;
    }, []);
    return result.reduce((total, cur) => [...total, ...cur], []);
};
export const computeTagIndex = (startTime, lastIndex, curTime) => {
    if (curTime - startTime <= DURATION_MIN) {
        return lastIndex + 1;
    }
    return 0;
};
const splitMsgs = (msgs, checkMethod) => {
    const twoDimensionalArr = [];
    return msgs.reduce((total, item) => {
        if (checkMethod(item) === -1) {
            total.push([item]);
        }
        else if (checkMethod(item) === 0) {
            total.push([item]);
        }
        else {
            const lastSubMsgs = total[total.length - 1];
            lastSubMsgs.push(item);
        }
        return total;
    }, twoDimensionalArr);
};
export const addTimelineTag = (msgs, currentTime = 0, currentIndex = 0) => {
    const maxDistance = 5 * 60 * 1000;
    return msgs.map(item => {
        const { time } = item;
        if (time - currentTime >= maxDistance) {
            item.timeTagIndex = 0;
            item.timeTagValue = time;
            currentIndex = 0;
            currentTime = time;
        }
        return item;
    });
};
export const findTag = (msgs, pos) => {
    const lastMsg = msgs[pos || msgs.length - 1] || {
        timeTagIndex: 0,
        timeTagValue: 0,
    };
    const { timeTagIndex, timeTagValue } = lastMsg;
    return {
        timeTagIndex,
        timeTagValue,
    };
};
export const findPreTag = () => { };
